import axios from "axios";
import config from "../config";
import { ApiSuccess } from "./api_helper";

const apiBase = config.api.API_URL;

export type DnsRecord = {
  type: string;
  name: string;
  value: string;
  purpose: "tracking" | "ses" | string;
  status?: string;
};

export type DnsDiagnostics = {
  mode?: string;
  expected_ns?: string[];
  expected_a?: string;
  expected_cname?: string;
  found_ns?: string[];
  found_a?: string[];
  found_cname?: string[];
  conflict_cname?: string | null;
  conflict_legacy_ip?: string | null;
  ns_ok?: boolean;
  a_ok?: boolean;
  cname_ok?: boolean;
  /** Zona apex na Br Domínio — sugerir modo NS (sem jargão de região SES). */
  suggest_ns_mode?: boolean;
  apex_zone?: string;
};

export type SendingSetup = {
  sending_domain: string | null;
  from_email: string | null;
  from_name: string | null;
  /** Caixa humana para respostas (pode ser apex fora do domínio SES). */
  reply_to: string | null;
  ses_identity_status: string;
  ses_region: string | null;
  tracking_hostname: string | null;
  tracking_cname_target: string | null;
  /** cname (padrão) | ns (Br Domínio) */
  dns_delegation_mode: "cname" | "ns" | string;
  auth_dns_nameservers?: string[];
  dns_diagnostics?: DnsDiagnostics | null;
  tracking_status: string;
  step_dns_ok: boolean;
  step_ses_ok: boolean;
  step_ssl_ok: boolean;
  dns_records: DnsRecord[];
  verified_at: string | null;
  sending_setup_checked_at?: string | null;
  tracking_ssl_attention?: boolean;
  is_ready: boolean;
};

export type UpdateSendingSetupPayload = {
  tracking_hostname: string;
  sending_domain: string;
  from_email: string;
  from_name: string;
  reply_to?: string | null;
};

export const getSendingSetup = (): Promise<ApiSuccess<SendingSetup>> => {
  return axios.get(apiBase + "/me/sending-setup");
};

export const updateSendingSetup = (
  payload: UpdateSendingSetupPayload
): Promise<ApiSuccess<SendingSetup>> => {
  return axios.put(apiBase + "/me/sending-setup", payload);
};

/** Poll SES + CNAME real (“Verificar de novo”). */
export const verifySendingSetup = (): Promise<ApiSuccess<SendingSetup>> => {
  return axios.post(apiBase + "/me/sending-setup/verify");
};
